import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IBulkCalDriftWarningData } from 'src/app/models/calDriftBreach.model';

@Component({
    standalone: false,
    selector: 'app-bulk-cal-drift-warning-dialog',
    templateUrl: './bulk-cal-drift-warning-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./../../shared/form/form.component.scss', './bulk-cal-drift-warning-dialog.component.scss'],
})
export class BulkCalDriftWarningDialogComponent {
    constructor(
        private readonly dialogRef: MatDialogRef<BulkCalDriftWarningDialogComponent, boolean>,
        @Inject(MAT_DIALOG_DATA) public data: IBulkCalDriftWarningData,
    ) {}

    onContinue(): void {
        this.dialogRef.close(true);
    }

    onCancel(): void {
        this.dialogRef.close(false);
    }
}
